import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { PHONE, PHONE_HREF, EMAIL, BRAND } from "@/lib/config";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.postNewsletter(email);
      toast.success("Welcome to the inner circle.");
      setEmail("");
    } catch (e) { toast.error("Something went wrong."); }
  };

  return (
    <footer className="bg-espresso border-t border-white/10 mt-24">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <h3 className="font-serif text-2xl text-cream">{BRAND}</h3>
          <p className="text-cream/60 text-sm mt-3 leading-relaxed">
            Elite recovery sanctuaries for home and commercial wellness. Saunas, cold plunges & hot tubs, delivered with care.
          </p>
        </div>
        <div>
          <h4 className="overline mb-4">Shop</h4>
          <ul className="space-y-2 text-sm text-cream/70">
            <li><Link to="/shop/sauna" className="hover:text-gold">Saunas</Link></li>
            <li><Link to="/shop/cold-plunge" className="hover:text-gold">Cold Plunges</Link></li>
            <li><Link to="/shop/hot-tub" className="hover:text-gold">Hot Tubs</Link></li>
            <li><Link to="/shop/accessory" className="hover:text-gold">Accessories</Link></li>
            <li><Link to="/commercial" className="hover:text-gold">Commercial Solutions</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="overline mb-4">Learn</h4>
          <ul className="space-y-2 text-sm text-cream/70">
            <li><Link to="/quiz" className="hover:text-gold">Find Your Match</Link></li>
            <li><Link to="/guides" className="hover:text-gold">Buying Guides</Link></li>
            <li><Link to="/about" className="hover:text-gold">About Us</Link></li>
            <li><Link to="/faq" className="hover:text-gold">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
            <li><Link to="/policies/refund-policy" className="hover:text-gold">Refund Policy</Link></li>
            <li><Link to="/policies/privacy-policy" className="hover:text-gold">Privacy Policy</Link></li>
            <li><Link to="/policies/terms-of-service" className="hover:text-gold">Terms of Service</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="overline mb-4">Join the Ritual</h4>
          <p className="text-cream/60 text-sm mb-3">Recovery tips & private offers.</p>
          <form onSubmit={submit} className="flex">
            <input data-testid="newsletter-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="Email address"
              className="flex-1 bg-charcoal border border-white/10 px-3 py-2 text-sm text-cream outline-none focus:border-gold" />
            <button data-testid="newsletter-submit" type="submit"
              className="bg-gold text-espresso px-4 text-sm font-medium hover:bg-amber transition-colors">Join</button>
          </form>
          <div className="mt-5 text-sm text-cream/60 space-y-1">
            <a href={PHONE_HREF} className="block hover:text-gold">{PHONE}</a>
            <a href={`mailto:${EMAIL}`} className="block hover:text-gold">{EMAIL}</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-cream/40">
        © {new Date().getFullYear()} {BRAND}. Powered by Shopify. Crafted for elite recovery.
      </div>
    </footer>
  );
};
